export default __webpack_public_path__ + "static/media/logo.db2a1632.svg";